import React from 'react';

import ButtonBase from '../Button/ButtonBase';
import Icon from '../Icon/Icon';
import { TIconButton } from './types';

type TIconButtonBase = TIconButton & {
  kind: 'primary' | 'secondary' | 'tertiary' | 'destructive' | 'destructive-ghost' | 'action-image';
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const IconButtonBase = ({ name, color, ariaLabel, ...rest }: TIconButtonBase) => (
  <ButtonBase {...rest} aria-label={ariaLabel || name} isIconButton>
    <Icon name={name} color={color} />
  </ButtonBase>
);

export default IconButtonBase;
